import { useEffect, useState } from 'react';
import UserDetailContainer from './userDetails';
import UserSettingContainer from './userSettingDetails';
import UserCreationSteps from './userCreationSteps';
import { useLocation } from 'react-router-dom';
import {
  AddUserAccountInitialValues,
  AddUserDetailsInitialValidations,
} from '../../../../../../initial-values';
import { AddUserAccountDto } from '../../../../../../types';
import { addUserAccount } from '../../../../../../api/accounts';
import QuickUserNav from './QuickUserNav';

function CreateUserAccount() {
  const location = useLocation();
  const account_number = new URLSearchParams(location.search).get(
    'account_number'
  );
  const [showUserDetailForm, setShowUserDetailForm] = useState(true);
  const [showUserSettingForm, setShowUserSettingForm] = useState(false);
  const [showUserCreation, setShowUserCreation] = useState(false);
  const [finalResponse, setFinalResponse] = useState<any>(null);
  const [formData, setFormData] = useState<AddUserAccountDto>(
    AddUserAccountInitialValues
  );
  const [userDetailsFormValidations, setUserDetailsFormValidations] =
    useState<any>(AddUserDetailsInitialValidations);
  function handleCreateUser() {
    let payload = formData;
    payload.role = Number(payload.role);
    if (!formData.is_business_central) {
      delete payload.bc_username;
      delete payload.bc_location_code;
      delete payload.bc_cost_center;
      delete payload.bc_branch_code;
    }
    payload.carrier = payload.carriers;
    delete payload.carriers;
    addUserAccount(payload)
      .then((response) => {
        if (!response?.data?.is_error) {
          setFinalResponse(response?.data?.content);
        }
      })
      .catch((e) => {
        setShowUserDetailForm(true);
      });
  }
  useEffect(() => {
    if (account_number) {
      setFormData({
        ...formData,
        account: account_number,
      });
    }
  }, [account_number]);
  return (
    <div className='container-fluid my-4'>
      {!showUserCreation && (
        <div className='row mt-4'>
          <QuickUserNav
            currentShipmentStatus={
              showUserDetailForm
                ? 'DetailForm'
                : showUserDetailForm
                ? 'SettingForm'
                : ''
            }
          />
        </div>
      )}
      {showUserDetailForm && (
        <UserDetailContainer
          setShowUserDetailForm={setShowUserDetailForm}
          setShowUserSettingForm={setShowUserSettingForm}
          formData={formData}
          setFormData={setFormData}
          formValidations={userDetailsFormValidations}
          setFormValidations={setUserDetailsFormValidations}
        />
      )}
      {showUserSettingForm && (
        <UserSettingContainer
          setShowUserDetailForm={setShowUserDetailForm}
          setShowUserSettingForm={setShowUserSettingForm}
          formData={formData}
          setFormData={setFormData}
          setShowUserCreation={setShowUserCreation}
          onSave={handleCreateUser}
        />
      )}
      {showUserCreation && <UserCreationSteps response={finalResponse} />}
    </div>
  );
}

export default CreateUserAccount;
